import { NgModule } from '@angular/core';
import { MaterialsModule } from '../shared/modules/material.module';
import { AdminStationRoutingModule } from './admin-station-routing.module';

@NgModule({
  imports: [AdminStationRoutingModule, MaterialsModule],
  declarations: [],
})
export class AdminStationModule {}
